import * as React from "react";
import { Loader } from "@grandvisionhq/common";
/* empty css                                                                               */
const DeliveryIndicatorLoader = () => /* @__PURE__ */ React.createElement("div", { className: "delivery-indicator delivery-indicator-loader" }, /* @__PURE__ */ React.createElement(Loader, { className: "delivery-indicator-loader__loader" }));
export {
  DeliveryIndicatorLoader
};
//# sourceMappingURL=DeliveryIndicatorLoader.js.map
